import { call, put, fork } from 'redux-saga/effects'
import { isEmpty, includes, isUndefined } from 'lodash-es'
import URI from 'urijs'
import { exportSagas } from '../shared/utils/sagas'
import { actionNames, showNotification } from './actions'
import { loadSiteData } from './api'
import { watchRefetchSiteData, watchFetchSettings } from './sagas.shared'

const getWebinarPresenterUrlParams = () => {
  const url = URI(window.location.href)
  const urlParams = url.path().match(/\/webinar\/presenter\/(\d+)\/(.+)/) || []

  // are we webinar speaker?
  if (!isEmpty(urlParams)) {
    return {
      live_id: urlParams[1],
      presenter_token: urlParams[2],
      include_presentation_p: 1,
    }
  }

  // are we a webinar producer or webinar audience?
  if (
    includes(url.path(), 'webinar/producer') ||
    !isUndefined(window.LIVE_ID)
  ) {
    return {
      include_presentation_p: 1,
    }
  }

  return {}
}

function* fetchSiteData(params) {
  try {
    const data = yield call(loadSiteData, params)
    yield put({ type: actionNames.INIT_APP_SUCCESS, data })
  } catch (err) {
    yield put(
      showNotification({
        type: 'error',
        message: 'The application could not be loaded.',
      })
    )
  }
}

function* init() {
  const params = getWebinarPresenterUrlParams()

  yield fork(watchRefetchSiteData, params)
  yield fork(watchFetchSettings)

  yield fork(fetchSiteData, params)
}

export default exportSagas([init], actionNames.INIT_APP, actionNames.LEAVE_APP)

export { fetchSiteData, watchFetchSettings }
